/* eslint-disable no-console */
import Splide from '@splidejs/splide';
import { Translations } from '../utils';

import './related.scss';

/**
 * version    1.0
 * class      <type> (Related)
 * classdesc  Component that manage the page Related
 */
export class Related {
  constructor() {
    this.el = document.querySelector('.related__content');
    if (!this.el) return;

    this.breakpoint = 992;
    this.splide = null;

    this.init();
  }

  init() {
    this.checkSlider();
    window.addEventListener('resize', () => this.checkSlider());
  }

  checkSlider() {
    const isMobile = window.innerWidth < this.breakpoint;

    if (isMobile && !this.splide) {
      this.initSlider();
    }

    if (!isMobile && this.splide) {
      this.destroySlider();
    }
  }

  initSlider() {
    this.splide = new Splide(this.el, {
      type: 'slide',
      arrows: false,
      pagination: false,
      perPage: 1,
      gap: '0.5rem',
      padding: { right: '20%' },
      trimSpace: false,
      i18n: Translations.getSplideI18n(),
    });

    this.splide.mount();

    const prev = this.el.querySelector('.splide-arrow--prev');
    const next = this.el.querySelector('.splide-arrow--next');

    const updateArrows = () => {
      const { index } = this.splide;
      const last = this.splide.length - 1;

      // Se sono alla prima slide disabilito prev
      if (index === 0) {
        prev.classList.add('is-disabled');
      } else {
        prev.classList.remove('is-disabled');
      }

      // Se sono all’ultima slide disabilito next
      if (index === last) {
        next.classList.add('is-disabled');
      } else {
        next.classList.remove('is-disabled');
      }
    };

    // primo chek al caricamento
    updateArrows();
    // secondo check al cambio slide
    this.splide.on('mounted move', updateArrows);

    prev.addEventListener('click', () => this.splide.go('<'));
    next.addEventListener('click', () => this.splide.go('>'));
  }

  destroySlider() {
    this.splide.destroy(true);
    this.splide = null;
  }
}
